import styled from 'styled-components';
import { media } from '../../styles/theme';

export const Container = styled.nav`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: ${({ theme }) => theme.espaco.sm};
  margin: ${({ theme }) => theme.espaco.md} 0;
`;

export const Info = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: ${({ theme }) => theme.espaco.lg};
  color: ${({ theme }) => theme.cores.inkSecondary};
  font-size: ${({ theme }) => theme.fonte.small};

  .intervalo {
    font-variant-numeric: tabular-nums;
  }

  ${media.mobile} {
    width: 100%;
    justify-content: space-between;
  }
`;

export const SeletorPorPagina = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.espaco.sm};

  .campo {
    position: relative;
    display: inline-flex;
  }

  select {
    height: ${({ theme }) => theme.alturaControle.sm};
    padding: 0 28px 0 10px;
    border: 1px solid ${({ theme }) => theme.cores.border};
    border-radius: ${({ theme }) => theme.raio.sm};
    background-color: ${({ theme }) => theme.cores.card};
    color: ${({ theme }) => theme.cores.ink};
    font-size: ${({ theme }) => theme.fonte.small};
    font-variant-numeric: tabular-nums;
    appearance: none;
    cursor: pointer;

    &:hover {
      border-color: ${({ theme }) => theme.cores.primary};
    }

    &:focus-visible {
      outline: none;
      border-color: ${({ theme }) => theme.cores.primary};
      box-shadow: 0 0 0 3px ${({ theme }) => theme.cores.foco};
    }
  }

  .seta {
    position: absolute;
    right: 10px;
    top: 50%;
    transform: translateY(-50%);
    display: flex;
    color: ${({ theme }) => theme.cores.inkMuted};
    pointer-events: none;
  }

  ${media.mobile} {
    select {
      height: ${({ theme }) => theme.alturaControle.mobile};
      /* 16px evita o zoom do iOS ao focar */
      font-size: 16px;
    }
  }
`;

export const Navegacao = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.espaco.xs};
  margin-left: auto;

  .resumo {
    display: none;
    color: ${({ theme }) => theme.cores.inkSecondary};
    font-size: ${({ theme }) => theme.fonte.body};
  }

  ${media.mobile} {
    width: 100%;
    justify-content: space-between;

    .numero {
      display: none;
    }

    .resumo {
      display: block;
    }
  }
`;

export const Button = styled.button<{ $isActive?: boolean }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: ${({ theme }) => theme.espaco.xs};
  min-width: ${({ theme }) => theme.alturaControle.sm};
  height: ${({ theme }) => theme.alturaControle.sm};
  padding: 0 10px;
  border: 1px solid ${({ $isActive, theme }) => ($isActive ? theme.cores.primary : theme.cores.border)};
  border-radius: ${({ theme }) => theme.raio.sm};
  background-color: ${({ $isActive, theme }) => ($isActive ? theme.cores.primary : theme.cores.card)};
  color: ${({ $isActive, theme }) => ($isActive ? theme.cores.inkInverse : theme.cores.ink)};
  font-size: ${({ theme }) => theme.fonte.small};
  font-weight: 500;
  font-variant-numeric: tabular-nums;

  &:hover:not(:disabled) {
    border-color: ${({ theme }) => theme.cores.primary};
  }

  &:disabled {
    opacity: 0.45;
  }

  ${media.mobile} {
    height: ${({ theme }) => theme.alturaControle.mobile};
    min-width: ${({ theme }) => theme.alturaControle.mobile};
    padding: 0 14px;
  }
`;
